import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Vendor {
    _id: string;
    name: string;
    type: string;
    status: string;
    transactions: number;
    successRate: number;
    avgResponseTime: number;
    apiEndpoint: string;
    apiKey?: string;
    createdAt?: string;
    updatedAt?: string;
    __v?: number;
}

@Injectable({ providedIn: 'root' })
export class VendorService {
    apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getVendors(): Observable<Vendor[]> {
        return this.http.get<Vendor[]>(`${this.apiUrl}/admin/vendors`);
    }

    getVendorById(id: string): Observable<Vendor> {
        return this.http.get<Vendor>(`${this.apiUrl}/admin/vendors/${id}`);
    }

    createVendor(payload: Partial<Vendor>): Observable<Vendor> {
        return this.http.post<Vendor>(`${this.apiUrl}/admin/vendors`, payload);
    }

    updateVendor(id: string, payload: Partial<Vendor>): Observable<Vendor> {
        return this.http.patch<Vendor>(`${this.apiUrl}/admin/vendors/${id}`, payload);
    }

    checkVendorHealth(id: string): Observable<any> {
        return this.http.patch<any>(`${this.apiUrl}/admin/vendors/${id}/health`, {});
    }
}
